module.exports = __webpack_public_path__ + "fonts/Ubuntu-Bold.fec2d0f.ttf";